var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OpenSeadragon',{key:'penseadragon',ref:"openseadragon",staticClass:"has-background-dark",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"imageViewer","options":_vm.options},on:{"open":_vm.onOpen}})}
var staticRenderFns = []

export { render, staticRenderFns }